/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/8/1 9:13
 */
import React from 'react'
import Loading from 'component/Loading/Loading'

const context = React.createContext<Partial<WithShopsPropType>>({})
const { Provider, Consumer } = context

interface WithShopsPropType {
  shops: Shop[],
  fetchShops: NoArgVoidFunc,
  currentShop: Shop,
}
/**
 * 高阶组件，传递店铺列表
 * @param Component {function | React.Component}
 * @return {function(*): *}
 */
export default Component => function withShops (props) {
  return (
    <Consumer>
      {({ shops, fetchShops, currentShop }) => (
        shops
          ? (
            <Component
              {...props}
              shops={shops}
              fetchShops={fetchShops}
              currentShop={currentShop}
            />
          )
          : <Loading />
      )}
    </Consumer>
  )
}

export { Provider as ShopsProvider, context as ShopsContext, WithShopsPropType }
